import React, { HTMLAttributes } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Loader' })(theme => ({
	root: {
		position: 'fixed',
		top: '0',
		left: '0',
		bottom: '0',
		right: '0',
		background: theme.palette.background.default,
		zIndex: 1
	},
	spinner: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		'& rect': {
			fill: theme.palette.primary.main
		}
	}
}));

type LoaderProps = HTMLAttributes<HTMLDivElement> & {
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
}

export const Loader: React.FC<LoaderProps> = (props) => {
	const { classes, className, ...other } = props;
	const { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	return (
		<div className={cx(styles.root, classes?.root, className)} {...other}>
			<svg xmlns="http://www.w3.org/2000/svg" className={cx(styles.spinner, classes?.spinner)} width="110px" height="110px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
				<g transform="rotate(0 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.875s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(45 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(90 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.625s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(135 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(180 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.375s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(225 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(270 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.125s" repeatCount="indefinite"></animate>
					</rect>
				</g><g transform="rotate(315 50 50)">
					<rect x="47.5" y="22.5" rx="2.25" ry="2.25" width="5" height="15">
						<animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate>
					</rect>
				</g>
			</svg>
		</div>
	);
};
